<template>
  <!-- <md-tab id="renew-upgrade-tab" md-label="Renew Upgrade" md-icon="desktop_mac">
  </md-tab> -->
  <collapse :collapse="['Renew Upgrade']" icon="keyboard_arrow_down" cardIcon="settings" color-collapse="info" :active="false">
    <template slot="md-collapse-pane-1">
      <div class="md-layout upgrade_card" v-if="subscriptionsInfo">
        <div class="md-layout-item md-medium-size-33 md-xsmall-size-100 md-size-33">
          <pricing-card-with-list
            icon-color="icon-success"
            class="pricing-card-with-list"
          >
            <h3 slot="category" class="category text-left">Basic</h3>
            <div slot="description" class="card-description">
              <div class="pricing-list-wrapper">
                <h5 class="pricing-list-title">Profiles</h5>
                <ul class="pricing-list">
                  <li class="pricing-list-item">
                    Industry Financial Profile<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Industry Market Profile<md-icon>close</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Sales Per Square Foot<md-icon>close</md-icon> 
                  </li>
                  <li class="pricing-list-item">
                    Market Demographic Profile<md-icon>close</md-icon> 
                  </li>
                  <li class="pricing-list-item">
                    Market Demographic Profile<md-icon>close</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Company Profile<md-icon>close</md-icon>
                  </li>
                </ul>
              </div>
              <div class="pricing-list-wrapper">
                <h5 class="pricing-list-title">Reports</h5>
                <ul class="pricing-list">
                  <li class="pricing-list-item">
                    Financial Report<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Market Report<md-icon>close</md-icon> 
                  </li>
                  <li class="pricing-list-item">
                   Business Valuation Report<md-icon>close</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Company Report<md-icon>close</md-icon>
                  </li>
                </ul>
              </div>
            </div>
            <div slot="footer">
              <div class="footer-note">
                Your current plan expires in
                {{ subscriptionsInfo.days_left }} days.
              </div>
              <md-button class="md-info md-round">Choose Plan</md-button>
            </div>
          </pricing-card-with-list>
        </div>
        <div class="md-layout-item md-medium-size-33 md-xsmall-size-100 md-size-33">
          <pricing-card-with-list
            icon-color="icon-success"
            class="pricing-card-with-list"
          >
            <h3 slot="category" class="category text-left">Pro</h3>
            <div slot="description" class="card-description">
              <div class="pricing-list-wrapper">
                <h5 class="pricing-list-title">Profiles</h5>
                <ul class="pricing-list">
                  <li class="pricing-list-item">
                    Industry Financial Profile<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Industry Market Profile<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Sales Per Square Foot<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Market Demographic Profile<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Market Demographic Profile<md-icon>close</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Company Profile<md-icon>close</md-icon>
                  </li>
                </ul>
              </div>
              <div class="pricing-list-wrapper">
                <h5 class="pricing-list-title">Reports</h5>
                <ul class="pricing-list">
                  <li class="pricing-list-item">
                    Financial Report<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Market Report<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Business Valuation Report<md-icon>close</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Company Report<md-icon>close</md-icon>
                  </li>
                </ul>
              </div>
            </div>
            <div slot="footer">
              <div class="footer-note"></div>
              <md-button class="md-info md-block md-round">Choose Plan</md-button>
            </div>
          </pricing-card-with-list>
        </div>
        <div class="md-layout-item md-medium-size-33 md-xsmall-size-100 md-size-33">
          <pricing-card-with-list
            icon-color="icon-success"
            class="pricing-card-with-list"
          >
            <h3 slot="category" class="category text-left">Premium</h3>
            <div slot="description" class="card-description">
              <div class="pricing-list-wrapper">
                <h5 class="pricing-list-title">Profiles</h5>
                <ul class="pricing-list">
                  <li class="pricing-list-item">
                    Industry Financial Profile<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Industry Market Profile<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Sales Per Square Foot<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Industry Vestimate Profile<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Market Demographic Profile<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Company Profile<md-icon class="success">check</md-icon>
                  </li>
                </ul>
              </div>
              <div class="pricing-list-wrapper">
                <h5 class="pricing-list-title">Reports</h5>
                <ul class="pricing-list">
                  <li class="pricing-list-item">
                    Financial Report<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Market Report<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Business Valuation Report<md-icon class="success">check</md-icon>
                  </li>
                  <li class="pricing-list-item">
                    Company Report<md-icon class="success">check</md-icon>
                  </li>
                </ul>
              </div>
            </div>
            <div slot="footer">
              <div class="footer-note"></div>
              <md-button class="md-info md-block md-round">Choose Plan</md-button>
            </div>
          </pricing-card-with-list>
        </div>
      </div>
    </template>
  </collapse>
</template>
<script>
import { PricingCardWithList, Collapse } from "@/components";

export default {
  name: "account-activity-tab",
  components: {
    PricingCardWithList,
    Collapse
  },
  data() {
    return {};
  },

  methods: {},
  computed: {
    subscriptionsInfo() {
      return this.$store.getters.subscriptionsInfo;
    },
  },
};
</script>
<style></style>
